import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-signin.mjs";
import { render } from "lit-html";
import { HbMain } from "../../hb-main/hb-main.ts";
import { getLanguage, redirect } from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import Strings from "../../../models/Strings.json";
const strings: any = Strings;

export class HbSignin extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;
    private passkey: HTMLAnchorElement;

    private signin: HTMLElement;
    private form: HTMLFormElement;
    private email: HTMLInputElement;
    private label: HTMLLabelElement;
    private password: HTMLElement;
    private code: HTMLInputElement;
    private codeBtn: HTMLButtonElement;
    private showBtn: HTMLButtonElement;
    private submitBtn: HTMLButtonElement;
    private message: HTMLParagraphElement;

    constructor() {
        super();
        render(template(null, getLanguage()), this);

        this.signin = this.querySelector("#hb-signin")!;
        this.form = this.querySelector("form")!;
        this.email = this.querySelector("#hb-signin-email")!;
        this.label = this.querySelector("label[for=hb-signin-code]")!;
        this.password = this.querySelector("#hb-signin-password")!;
        this.code = this.querySelector("#hb-signin-code")!;
        this.codeBtn = this.querySelector("#hb-signin-button")!;
        this.showBtn = this.querySelector("#hb-signin-show")!;
        this.submitBtn = this.querySelector("button[type=submit]")!;
        this.message = this.querySelector("#hb-signin-message")!;
        this.passkey = this.querySelector("#hb-signin-passkey")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.form.reset();
                this.message.textContent = "";
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-signin",
            override: true
        };

        this.modal = new Modal(this.signin, modalOptions, instanceOptions);
    }

    connectedCallback() {
        if (this.heartbank.isPasskeySupported())
            this.passkey.classList.remove("hidden");
        else this.passkey.classList.add("hidden");

        this.form.addEventListener("submit", this.handleSignin.bind(this));
        this.codeBtn.addEventListener("click", this.sendCode.bind(this));

        this.showBtn.addEventListener("click", () => {
            const lang = getLanguage();
            if (this.code.type === "password") {
                this.code.type = "text";
                this.showBtn.textContent = strings.signin6[lang];
            } else {
                this.code.type = "password";
                this.showBtn.textContent = strings.signin5[lang];
            }
        });

        this.code.addEventListener("input", (event: Event) => {
            const target = event.target as HTMLInputElement;
            target.value = target.value.replace(/\s+/g, "").toLowerCase();
            if (target.value.length === 6)
                this.submitBtn.classList.remove("hidden");
            else this.submitBtn.classList.add("hidden");
        });

        this.heartbank.addAuthStateListener((user) => {
            render(template(user, getLanguage()), this);

            // redundant with hb-login.ts
            //this.main.showSpinner();
            // const fragments = window.location.hash.split("/");
            // if (fragments[1] === "login") {
            //     if (this.heartbank.user) {
            //         if (this.heartbank.opener) {
            //             this.main.showSpinner();
            //             const status = await this.heartbank.getCustomToken();
            //             this.heartbank.opener.postMessage(
            //                 {
            //                     action:
            //                         status.color === "green"
            //                             ? "success"
            //                             : "error",
            //                     text: status.text,
            //                     token: status.token
            //                 },
            //                 "*"
            //             );
            //         } else if (this.heartbank.isInIframe) {
            //             this.main.showSpinner();
            //             const status = await this.heartbank.getCustomToken();
            //             this.heartbank.iframe.postMessage(
            //                 {
            //                     action:
            //                         status.color === "green"
            //                             ? "success"
            //                             : "error",
            //                     text: status.text,
            //                     token: status.token
            //                 },
            //                 "*"
            //             );
            //         } else {
            //             window.location.hash = "#/account";
            //         }
            //     } else {
            //         //render(template(user), this);
            //     }
            // }
            // //this.main.hideSpinner();
        });
    }

    show() {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    private async sendCode(event: Event) {
        this.main.showSpinner();
        this.message.style.color = "orange";
        this.message.textContent = strings.login9[getLanguage()];
        const email = this.email.value.trim();

        if (email) {
            const status = await this.heartbank.sendCode(email);

            this.codeBtn.textContent = strings.signin7[getLanguage()];
            this.label.classList.replace("hidden", "block");
            this.password.classList.replace("hidden", "inline-flex");

            this.message.textContent = status.text;
            this.message.style.color = status.color;
        } else {
            this.email.reportValidity();
            //this.message.textContent = "Email is required.";
            //this.message.style.color = "red";
        }

        //this.message.textContent = "";
        this.main.hideSpinner();
    }

    private async handleSignin(event: Event) {
        event.preventDefault();
        this.main.showSpinner();
        this.message.style.color = "orange";
        this.message.textContent = strings.login9[getLanguage()];

        const email = this.email.value.trim();
        const code = this.code.value.replace(/\s+/g, "").toLowerCase();

        if (email && code) {
            const status = await this.heartbank.signIn(email, code);
            this.message.textContent = status.text;
            this.message.style.color = status.color;
            redirect("login");
        } else if (!email) {
            this.email.reportValidity();
        } else if (!code) {
            this.code.reportValidity();
        }

        //this.message.textContent = "";
        this.main.hideSpinner();
    }

    // private async handleSignup(event: Event) {
    //     event.preventDefault();

    //     try {
    //         const user = await this.heartbank.signUp(
    //             this.email.value
    //             this.password.value
    //         );
    //         this.modal.hide();
    //         window.location.hash = "#/menu";
    //     } catch (error: any) {
    //         alert(`Error during signup: ${error.message}`);
    //     }
    // }

    // private async handleLogin(event: Event) {
    //     event.preventDefault();

    //     try {
    //         const user = await this.heartbank.signIn(
    //             this.email.value,
    //             this.password.value
    //         );
    //         this.modal.hide();
    //         window.location.hash = "#/menu";
    //     } catch (error: any) {
    //         alert("Error during login: " + error.message);
    //     }
    // }
}
